const Vars = {
	token: "0ea2897b224a0603ac1b0cf01a204b",
	domain: "https://cockpit.portfolio.danielwahl.lu/",
}

export default Vars;